/**
 * Leichte UI-Zustände rund um den Kurs-Screen:
 *  - aktiver Lernmodus (Schlüssel aus der Modus-Registry),
 *  - aufgedeckte Antwort-Hinweise (pro Frage),
 *  - angepinnte Frage (Pinned-Question-Flow im Fragenmodus).
 */
import { signal } from "@preact/signals";

/** Lernmodus, persistiert wie im Web unter `ki-kurs-modus-v2` ("normal"|"fragen"). */
const MODE_KEY = "ki-kurs-modus-v2";
const storedMode = localStorage.getItem(MODE_KEY) === "fragen" ? "fragen" : "normal";

export const courseMode = signal<string>(storedMode);

export function setCourseMode(id: string): void {
  courseMode.value = id;
  localStorage.setItem(MODE_KEY, id);
}

/** content_keys der Fragen, deren „Mitnehmen"-Hinweis sichtbar ist. */
export const revealedHints = signal<Set<string>>(new Set());

export function toggleHint(key: string): void {
  const next = new Set(revealedHints.value);
  if (next.has(key)) next.delete(key);
  else next.add(key);
  revealedHints.value = next;
}

export function isHintRevealed(key: string): boolean {
  return revealedHints.value.has(key);
}

/** Aktuell angepinnte Frage-ID (im Fragenmodus), null = keine. */
export const pinnedQuestionId = signal<string | null>(null);

export function setPinnedQuestion(id: string | null): void {
  pinnedQuestionId.value = id;
}
